angular.module('app.controllers', []).controller('EmptyCtrl', ['$scope', '$location'].append(function(self, $location) {
  var params;
  self.tab = 1;
  self.tab_pre = false;
  params = $location.search();
  if (params && angular.isDefined(params.tab)) {
    self.tab_pre = true;
    return self.tab = parseInt(params.tab);
  }
}));
